module.exports = __webpack_public_path__ + "static/media/Buss.4cfd6ef5.PNG";